<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :id="id"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
    >
        <ul class="nav nav-tabs mb-5">
            <li class="nav-item">
                <a
                    href="#"
                    @click="$event.preventDefault(); tab ='general'"
                    class="nav-link"
                    :class="{active:tab == 'general'}"
                >{{$t('General')}}</a>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    @click="$event.preventDefault(); tab ='products'"
                    class="nav-link"
                    :class="{active:tab == 'products'}"
                >{{$t('Consumables')}}</a>
            </li>
        </ul>
        <div class="mb-4" style="min-height:60vh; overflow:auto">
            <div class="row" v-if="tab == 'general'">
                <div class="col-2 col-md-2">
                    <div class="form-group">
                        <label>{{$t('Code')}}</label>
                        <b-form-input
                            v-model.trim="data.code"
                            type="text"
                            :state="validation('code')"
                            :placeholder="$t('Ex.: A001')"
                        ></b-form-input>
                    </div>
                </div>
                <div class="col-10 col-md-10">
                    <div class="form-group">
                        <label>{{$t('Treatment name')}}</label>
                        <b-form-input
                            v-model.trim="data.label"
                            type="text"
                            :state="validation('label')"
                            :placeholder="$t('Ex.: Primary consultation')"
                        ></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Service')}}</label>
                        <b-form-select
                            v-model.trim="data.serviceId"
                            type="text"
                            :options="services"
                            :state="validation('serviceId')"
                            placeholder="Service"
                        ></b-form-select>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Price')}}</label>
                        <money-field
                            v-model.trim="data.price"
                            :state="validation('price')"
                            placeholder="Treatment price"
                        ></money-field>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Duration (Min)')}}</label>
                        <b-form-input
                            v-model.trim="data.duration"
                            type="text"
                            :state="validation('duration')"
                            :placeholder="$t('Treatment duration')"
                        ></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Buffer time (Min)')}}</label>
                        <b-form-input
                            v-model.trim="data.bufferDuration"
                            type="text"
                            :state="validation('bufferDuration')"
                            :placeholder="$t('Time required to prepare to the next treatment')"
                        ></b-form-input>
                    </div>
                </div>

                <div class="col-12 col-md-12">
                    <div class="form-group">
                        <label>{{$t('Description')}}</label>
                        <b-form-textarea
                            v-model.trim="data.description"
                            type="text"
                            :state="validation('description')"
                            :placeholder="$t('Short description of treatment')"
                        ></b-form-textarea>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <custom-switch
                        :title="$t('Public treatment')"
                        id="isPublic"
                        v-model="data.public"
                        :subtitle="$t('Public treatments will be published')"
                    ></custom-switch>
                </div>
            </div>

            <div class="row" v-if="tab == 'products'">
                <div class="col">
                    <div class="card" v-for="(product, idx) in data.products" :key="idx">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-auto">
                                    <avatar
                                        type="circle"
                                        v-if="product.avatar"
                                        :src="product.avatar.preview"
                                        size="avatar-xs"
                                    ></avatar>
                                </div>
                                <div class="col-auto">{{product.label}}</div>
                                <div class="col"></div>
                                <div class="col-2">
                                    <b-input-group size="sm" :append="product.measurement">
                                        <b-form-input v-model.trim="product.quantity" type="text" placeholder="q-ty"></b-form-input>
                                    </b-input-group>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-white btn-sm" @click="deleteProduct(idx)">
                                        <i class="fe fe-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-white" @click="openModal({id:'AddItemModal'})">
                        <i class="fe fe-plus"></i>
                        {{$t('Add item')}}
                    </button>
                </div>
            </div>
        </div>
        <add-item-modal :saveAction="addItem" id="AddItemModal"></add-item-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import MoneyField from "@/components/MoneyField.vue";
import Avatar from '@/components/Avatar.vue'
import AddItemModal from '@/Pages/Appointments/AddItemModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'

export default {
    name: 'bundle-modal',
    props: ['id', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        Avatar,
        MoneyField,
        CustomSwitch,
        AddItemModal,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            title: 'Treatment',
            tab: 'general',
            errors: {},
        }
    },
    computed: {
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapGetters('service', {
            findServicesInStore: 'find'
        }),
        services() {
            const data = this.findServicesInStore(this.params).data;
            const result = [];
            data.forEach(item => {
                result.push({ text: item.label, value: item._id });
            })

            return result;

        }
    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
        })
    },

    methods: {
        ...mapActions('treatment', ['create', 'patch']),
        saveAction() {

            let promise, successMessage;

            if (this.data._id) {
                promise = this.patch([this.data._id, this.data]);
                successMessage = 'Treatment has been saved';
            } else {
                promise = this.create(this.data);
                successMessage = 'Treatment has been created';
            }

            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: successMessage
                });
            });

            promise.catch(err => {
                this.errors = err.errors;
            });


        },
        addItem(item) {
            console.log('item', item);
            if (!this.data.products) {
                this.$set(this.data, 'products', [item.product]);
            } else {
                this.data.products.push(item.product);
            }
        },
        deleteProduct(idx) {
            this.data.products.splice(idx, 1);
        },
        shown() {

        },



        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
